// Storage keys for shared/auth.
// See react-rewrite-plan.md sections 8.2 and 11.2 platform-auth-session.
//
// These keys live in shared/auth (not shared/storage) so the entire surface
// that reads or writes auth state is funneled through this slice.

export const AUTH_STORAGE_KEYS = {
  // Local dev only: dev token for persona switching.
  token: 'agenthub:auth-token',
  // Cached session user info.
  session: 'agenthub:session',
  // Per-login correlation id shared across tabs.
  sessionKey: 'agenthub:session-key',
} as const;

export type AuthStorageKey =
  (typeof AUTH_STORAGE_KEYS)[keyof typeof AUTH_STORAGE_KEYS];
